// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");

function InlineWarning__Jsx3(props) {
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: "text-tan-error-500 text-base leading-6 px-4 py-5 border-b border-tan-error-500 bg-tan-cherub"
            });
}

var make = InlineWarning__Jsx3;

exports.make = make;
/* react/jsx-runtime Not a pure module */
